/**
 * Optional observability bootstrap.
 * Both Sentry and Google Analytics are env-driven: if the respective env var
 * is missing or empty, this module is a silent no-op so production builds without
 * the keys continue to work unchanged.
 */
import * as Sentry from '@sentry/react';

export function initObservability() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (dsn) {
    try {
      Sentry.init({
        dsn,
        environment: process.env.REACT_APP_ENV || 'production',
        tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES || '0.1'),
        // Ignore noisy network errors that aren't actionable
        ignoreErrors: ['ResizeObserver loop limit exceeded', 'Network Error'],
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Sentry init failed:', e);
    }
  }

  const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (gaId && typeof window !== 'undefined') {
    try {
      const s = document.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      // eslint-disable-next-line prefer-rest-params
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', gaId, { anonymize_ip: true });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Analytics init failed:', e);
    }
  }
}

/** Fire a custom analytics event when configured. Safe no-op otherwise. */
export function trackEvent(name, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch { /* no-op */ }
}
